import { formatDate } from '../../../../utils/dateFormat';
export { formatDate };

// Memoized status renderer
export const renderStatus = (value) => {
  const getStatusStyle = (status) => {
    switch(status?.toUpperCase()) {
      case 'ARRIVED':
      case 'ACTIVE':
        return 'bg-green-100 text-green-800';
      case 'DEMOBILIZED':
        return 'bg-blue-100 text-blue-800';
      case 'IDLE':
        return 'bg-yellow-100 text-yellow-800';
      case 'PENDING':
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  
  return (
    <span className={`px-2 py-1 rounded-full text-base ${getStatusStyle(value)}`}>
      {value || "Pending"}
    </span>
  );
};

// Memoized columns configuration (moved outside component to prevent recreation)
export const MOBILIZATION_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'project', title: 'PROJECT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'border_number', title: 'BORDER NUMBER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { 
    key: 'arrival_date', 
    title: 'ARRIVAL DATE', 
    searchable: true,
    render: formatDate
  },
  { key: 'aging', title: 'AGING', searchable: false },
  { 
    key: 'status', 
    title: 'STATUS', 
    searchable: true,
    render: renderStatus
  },
  { key: 'global_select', title: 'CLIENT, SALARY & OTHERS', searchable: false },
  { key: 'local_select', title: 'SELECT EMPLOYEE', searchable: false }
];

// Constants for better maintainability
export const MOBILIZATION_CONFIG = {
  API_ENDPOINT: "/mobilization",
  DOWNLOAD_ENDPOINT: "/mobilization/download",
  DOWNLOAD_FILENAME: "Mobilization_Report",
  SEARCH_PLACEHOLDER: "Search across all columns...",
  NO_DATA_MESSAGE: "No mobilization data available",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000]
};

// Memoized searchable fields derived from columns
export const MOBILIZATION_SEARCHABLE_FIELDS = MOBILIZATION_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);